module.exports = __webpack_public_path__ + "img/byd.1d11ba00.svg";